<template>
  <div class="modal">
    <div class="broadcastinfo-modal">
      <!-- broadcastinfo-header -->
      <div class="broadcastinfo-header">
        <h1 class="broadcastinfo-headertitle">시간 설정</h1>
        <a class="common-close-iconwrap  cursor" tabindex="0" @click="onClickClose">
          <img class="common-close-iconwrap" src="/media/images/icon/close-black-icon.png" alt="close-black-icon.png" />
        </a>
      </div>
      <!-- broadcastinfo-form -->
      <div class="broadcastinfo-form">
        <!-- 지정시간 -->
        <div class="broadcastinfo-formitem">
          <div class="form-labelbox">
            <RadioBox :value="repeatType === 'S'" @click-radio="onClickRadio('S')" />
            <label class="form-label">지정시간</label>
          </div>
          <div class="form-selecttimebox">
            <CommonSelectTIme
              :value="selectTime"
              :isdisabled="repeatType === 'S' ? false : true"
              @change-value="onChangeValueSelectTime"
            />
          </div>
        </div>
        <!-- 반복주기 -->
        <div class="broadcastinfo-formitem">
          <div class="form-labelbox">
            <RadioBox :value="repeatType === 'R'" @click-radio="onClickRadio('R')" />
            <label class="form-label">반복주기</label>
          </div>
          <div class="form-repeatbox">
            <label class="form-repeboxlabel">운영시간</label>
            <div class="form-repeattime-box">
              <div class="form-repeattime-start">
                <CommonSelectTIme
                  :value="startTime"
                  :isdisabled="repeatType === 'R' ? false : true"
                  @change-value="onChangeValueStartTime"
                />
              </div>
              <div class="form-repeattime-end">
                <CommonSelectTIme
                  :value="endTime"
                  :isdisabled="repeatType === 'R' ? false : true"
                  @change-value="onChangeValueEndTime"
                />
              </div>
            </div>
          </div>

          <div class="form-repeatbox">
            <label class="form-repeboxlabel">주기</label>
            <div class="form-repeattime-box">
              <div class="form-repeattime-repeat">
                <SelectRepeatBox
                  :value="selectKey"
                  @click-item="onClickItem"
                  :isdisabled="repeatType === 'R' ? false : true"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="broadcastinfo-footer">
        <div class="cancel-btn">
          <BasicButton @click-btn="onClickClose" :boxsize="'sm'" :fontcolor="'ft-black'" :bgcolor="'bg-black200'">
            <template #btnname>취소</template>
          </BasicButton>
        </div>
        <div class="confirm-btn">
          <BasicButton :boxsize="'sm'" @click-btn="onSaveTime">
            <template #btnname>적용</template>
          </BasicButton>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import RadioBox from '../RadioBox/RadioBox.vue';
import CommonSelectTIme from '../common/CommonSelectTIme.vue';
import SelectRepeatBox from './SelectRepeatBox.vue';
import BasicButton from '../BasicButton/BasicButton.vue';
export default {
  props: {
    aibrandmusicid: {
      type: String,
      default: null,
      required: false
    },
    brandmusicid: {
      type: String,
      default: null,
      required: false
    },
    playtype: {
      type: String,
      default: 'S',
      required: false
    },
    selecttime: {
      type: String,
      default: null,
      required: false
    },
    starttime: {
      type: String,
      default: null,
      required: false
    },
    endtime: {
      type: String,
      default: null,
      required: false
    },
    repeattime: {
      type: String,
      default: null,
      required: false
    }
  },
  components: {
    RadioBox,
    BasicButton,
    CommonSelectTIme,
    SelectRepeatBox
  },
  emits: ['close-broadcastinfo', 'save-time'],
  data() {
    return {
      selectKey: -1,
      startTime: null,
      endTime: null,
      repeatType: 'S',
      selectTime: null
    };
  },
  created() {
    this.repeatType = this.playtype;
    this.startTime = this.starttime;
    this.endTime = this.endtime;
    this.selectTime = this.selecttime;
    this.selectKey = parseInt(this.repeattime);
  },
  methods: {
    onClickRadio(type) {
      if (type === 'S') {
        this.$gatag.event('web_broadcast_detail_page_static_time'); // 지정 시간
      } else if (type === 'R') {
        this.$gatag.event('web_broadcast_detail_page_periodic_time'); // 반복 주기
      }
      this.repeatType = type;
    },
    onChangeValueSelectTime(val) {
      this.selectTime = val;
    },
    onChangeValueStartTime(val) {
      this.startTime = val;
    },
    onChangeValueEndTime(val) {
      this.endTime = val;
    },
    onClickItem(key) {
      this.selectKey = parseInt(key);
    },
    onClickClose() {
      this.$emit('close-broadcastinfo');
    },
    onSaveTime() {
      this.$emit('save-time', {
        playType: this.repeatType,
        startTime: this.startTime,
        endTime: this.endTime,
        selectTime: this.selectTime,
        repeatTime: this.selectKey,
        brandMusicId: this.brandmusicid,
        aiBrandMusicId: this.aibrandmusicid
      });
    }
  }
};
</script>
<style scoped src="@/assets/css/broadcastinfov2/broadcastinfov2.css"></style>
